import BulletPointsCard from '../BulletPointsCard'
import List from '../../Icons/coaching/list.svg'
import Target from '../../Icons/coaching/target.svg'
import Trusted from '../../Icons/coaching/trusted.svg'

const bulletPoints = [
    {
        title: 'Target Criteria Guidance',
        description:
            'Receive expert advice on selecting the right target criteria for your market, such as vacant properties, absentee owners, and more.',
        icon: Target,
    },
    {
        title: 'Trusted Data Recommendations',
        description:
            'Learn about the most reliable data providers for your region.',
        icon: Trusted,
    },
    {
        title: 'List Building',
        description:
            'Get step-by-step guidance on building your list, or let us handle the entire process for you.',
        icon: List,
    },
]

function ListBuildingFunnel(props) {
    return (
        <BulletPointsCard
            {...props}
            title="Customized List Building"
            bulletPoints={bulletPoints}
            imagePath="/assets/coaching/2.png"
            imageAlt="A hand is placing the last white puzzle piece into a gap in a gray puzzle."
            imageTitle="Finding the missing piece."
            mobileImagePath={'/assets/coaching/2-mobile.png'}
        />
    )
}

export default ListBuildingFunnel
